import { useMemo } from "react";
import { useBranding } from "@/lib/branding/useBranding";
import { emailLogoHtml, emailSignatureHtml } from "@/lib/emailPreview";

export type MailPlacePreview = {
  /** True, sobald Name und Logo aus den Betriebsdaten bekannt sind. */
  known: boolean;
  samples: Record<string, string>;
  logoHtml: string;
  signatureHtml: string;
};

function formatGermanDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}.${month}.${date.getFullYear()}`;
}

/**
 * Betriebsdaten für die Mail-Vorschau.
 * Name, Logo und Grußformel kommen aus dem Briefkopf. Nur gastbezogene Felder bleiben Beispiele.
 */
export function useMailPlacePreview(now = new Date()): MailPlacePreview {
  const { branding, loading, logoUrl } = useBranding();
  const companyName = branding?.site_name?.trim() || "";
  const known = !loading && branding != null && companyName.length > 0;
  const today = formatGermanDate(now);

  return useMemo((): MailPlacePreview => {
    if (!known) {
      return { known, samples: { today }, logoHtml: "", signatureHtml: "" };
    }
    return {
      known,
      samples: { today, company_name: companyName },
      logoHtml: emailLogoHtml(logoUrl),
      signatureHtml: emailSignatureHtml(companyName),
    };
  }, [companyName, known, logoUrl, today]);
}
